import { isServerResponseError } from '@/core/utils/errorHandling';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { authApi } from '../auth.api';
const initiateAuthUser = createAsyncThunk('auth/initiateAuthUser', async (_, { dispatch, rejectWithValue, fulfillWithValue }) => {
    try {
        await dispatch(authApi.endpoints.getCurrentUser.initiate()).unwrap();
        return fulfillWithValue({ success: true });
    }
    catch (error) {
        console.error(`initiateAuthUser request error:`, error);
        if (isServerResponseError(error)) {
            if (error.status === 401)
                return rejectWithValue({ errorMessage: 'Get user data unauthorized server response' });
            return rejectWithValue({ errorMessage: `Server unexpected error with status ${error.status}` });
        }
        if (error instanceof Error) {
            return rejectWithValue({ errorMessage: `initiateAuthUser request failed with message: ${error.message}` });
        }
        return rejectWithValue({ errorMessage: 'Server unexpected error' });
    }
});
export { initiateAuthUser };
